export function InvoicesSkeleton() {
    return (
        <div className="bg-white dark:bg-[#1A1A1A] rounded-2xl border border-[#E5E7EB] dark:border-[#2A2A2A] overflow-hidden shadow-sm">
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-[#F9FAFB] dark:bg-[#262626] border-b border-[#E5E7EB] dark:border-[#2A2A2A]">
                            {[
                                "Invoice ID",
                                "Customer",
                                "Items",
                                "Amount",
                                "Status",
                                "Return Date",
                                "Actions",
                            ].map((header) => (
                                <th
                                    key={header}
                                    className={`px-6 py-4 text-xs font-semibold text-[#6B7280] dark:text-[#A0A0A0] uppercase tracking-wider ${header === "Items" ? "text-center" : ""
                                        }`}
                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-[#E5E7EB] dark:divide-[#2A2A2A]">
                        {[1, 2, 3, 4, 5].map((row) => (
                            <tr key={row} className="animate-pulse">
                                {/* Invoice ID + Date */}
                                <td className="px-6 py-4">
                                    <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-24 mb-2"></div>
                                    <div className="h-3 bg-gray-100 dark:bg-[#333333] rounded w-16"></div>
                                </td>
                                {/* Customer */}
                                <td className="px-6 py-4">
                                    <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-32"></div>
                                </td>
                                {/* Items */}
                                <td className="px-6 py-4">
                                    <div className="h-6 bg-gray-200 dark:bg-[#262626] rounded w-8 mx-auto"></div>
                                </td>
                                {/* Amount */}
                                <td className="px-6 py-4">
                                    <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-20"></div>
                                </td>
                                {/* Status */}
                                <td className="px-6 py-4">
                                    <div className="h-6 bg-gray-200 dark:bg-[#262626] rounded-full w-24"></div>
                                </td>
                                {/* Return Date */}
                                <td className="px-6 py-4">
                                    <div className="flex items-center gap-2">
                                        <div className="w-4 h-4 bg-gray-200 dark:bg-[#262626] rounded"></div>
                                        <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-20"></div>
                                    </div>
                                </td>
                                {/* Actions */}
                                <td className="px-6 py-4">
                                    <div className="flex items-center gap-2">
                                        <div className="w-8 h-8 bg-gray-200 dark:bg-[#262626] rounded-lg"></div>
                                        <div className="w-8 h-8 bg-gray-200 dark:bg-[#262626] rounded-lg"></div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <style jsx="true">{`
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .5; }
        }
      `}</style>
        </div>
    );
}
